const featImage =
  "https://readdy.ai/api/search-image?query=editorial-flat-vector-illustration-of-a-television-broadcast-contract-scene-with-two-facing-chairs-a-fountain-pen-signing-paper-and-a-bursting-flood-of-comment-bubbles-and-hearts-splitting-toward-a-smartphone-screen-in-the-middle-editorial-flat-vector-illustration-on-warm-cream-paper-background-with-terracotta-red-and-deep-melon-green-accent-palette-thin-elegant-line-art-with-subtle-paper-grain-magazine-cover-aesthetic-soft-minimal-composition-generous-negative-space-no-text-no-watermark&width=1000&height=660&seq=gw51-featured-01&orientation=landscape";

const facts = [
  { label: "类型", value: "解约 / 对线" },
  { label: "热度", value: "全站 Top 1" },
  { label: "时间跨度", value: "06-11 → 08-31" },
];

export default function FeaturedEvent() {
  return (
    <section id="zhuanti" className="mx-auto max-w-[1240px] scroll-mt-24 px-4 md:px-6">
      <div className="flex items-end justify-between border-b border-foreground-200 pb-4">
        <div>
          <p className="flex items-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-fire-line h-4 w-4" />
            本期主打 · 大图详读
          </p>
          <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
            本期事件速览
          </h2>
        </div>
        <span className="hidden whitespace-nowrap text-xs text-foreground-500 md:block">更新 · 2026.09.06</span>
      </div>

      <article className="mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-100">
        <div className="grid lg:grid-cols-[1.05fr_1.25fr]">
          <div className="relative order-2 min-h-[220px] lg:order-1">
            <img
              src={featImage}
              alt="顶流主播与机构解约风波事件详情配图"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-800 backdrop-blur">
              <i className="ri-vidicon-line h-4 w-4 text-primary-600" />
              深度复盘
            </div>
          </div>

          <div className="order-1 p-6 md:p-8 lg:order-2 lg:p-10">
            <div className="flex flex-wrap items-center gap-2">
              {["解约风波", "隔空对线", "反转"].map((t) => (
                <span
                  key={t}
                  className="inline-flex items-center rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-800"
                >
                  {t}
                </span>
              ))}
            </div>

            <h3 className="mt-4 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
              从一句「想单干」，到百万弹幕的对线——
              <span className="text-primary-600">一场没有赢家的解约</span>
            </h3>

            <p className="mt-4 max-w-xl leading-7 text-foreground-700">
              很多人只看到了「官宣分道扬镳」的最后两行字。可真正的故事，藏在 3 万字合同、
              三段深夜直播和一段被反复转发的旧录像里。五1吃瓜用一条时间线，把谁先开口、
              谁先发难、又在哪里反转，一帧一帧讲给你听。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-6">
              {facts.map((f) => (
                <div key={f.label}>
                  <p className="text-xs text-foreground-500">{f.label}</p>
                  <p className="mt-1 font-medium text-foreground-900">{f.value}</p>
                </div>
              ))}
            </div>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#laiqu"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600"
              >
                看完整来龙去脉
                <i className="ri-arrow-right-line h-4 w-4" />
              </a>
              <a
                href="#neimu"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-secondary-600"
              >
                <i className="ri-focus-3-line h-4 w-4" />
                直奔内幕细节
              </a>
            </div>
          </div>
        </div>
      </article>
    </section>
  );
}